import { render } from "./version-copyright.html?vue&type=template&id=e252040a&ts=true"
import script from "./version-copyright.vue?vue&type=script&lang=ts"
export * from "./version-copyright.vue?vue&type=script&lang=ts"

import "./version-copyright.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__